import React from "react";
import Container from "../layout/Container";
import Reveal from "../motion/Reveal";
import { Cal, Rate, Reel } from "../characters/Character";
import { Squiggle } from "../characters/Decor";
import { useI18n } from "../../i18n/I18nProvider";

const CHARACTERS = [Cal, Rate, Reel];

const Social = () => {
  const { t } = useI18n();
  const cards = t("social.cards");

  return (
    <section className="wash-sun relative overflow-hidden py-16 md:py-24" aria-label={t("social.title")}>
      <Squiggle className="pointer-events-none absolute -left-6 bottom-6 hidden w-28 md:block" />
      <Container>
        <Reveal>
          <p className="text-body font-medium text-accent">{t("social.kicker")}</p>
          <h2 className="mt-3 max-w-2xl text-heading font-bold tracking-heading text-ink md:text-heading-lg">
            {t("social.title")}
          </h2>
          <p className="mt-4 max-w-xl text-body text-mid-gray">{t("social.body")}</p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {cards.map((card, index) => {
            const Character = CHARACTERS[index % CHARACTERS.length];
            return (
              <article
                key={card.title}
                className="rounded-card border border-hairline bg-paper p-6 shadow-card"
              >
                <Character icon size={56} decorative />
                <h3 className="mt-4 text-subheading font-semibold text-ink">{card.title}</h3>
                <p className="mt-3 text-body text-mid-gray">{card.body}</p>
              </article>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Social;
